module.exports = __webpack_public_path__ + "img/icon_yuanzhanbaohu.cd38203b.png";